// the domain key is the trigger if we can show modal (certus.com used for testing on default theme)
// aside from the domain we also check the products in the cart
// if domain and productIds = show the modal upon user exit intent

export const exitModalData = {
  // 'certus.com': {
  //   coupon: 'TDSSAVE10',
  //   headline: 'Leaving so soon?',
  //   discount: 'Take 10% Off',
  //   subCopy: 'Click Continue to apply the discount and proceed with your purchase.',
  //   productIds: [
  //     '1efb9296-7240-4c5e-8954-6868421468eb', // Texas Parent Taught Driver Education
  //     '1dcb0155-e537-4c4c-97a9-08dd986d4b3a', // Texas Parent Taught Driver's Education w/ DMV Permit Prep
  //     '70efb450-8c97-4b5a-b82e-736b45ccc3b8', // Texas Self-Taught Driver Education
  //     '06881a75-c9fb-498a-92ff-08dce3af17cb', // Texas Self-Taught Driver Education
  //     '306138a0-62a4-42b2-3574-08ddad287d8d', // Texas Self Taught Driver Education + Permit Prep
  //   ],
  //   useNewUI: true,
  //   isTesting: true,
  // },
  'newyorksafetycouncil.com': {
    coupon: 'NYSC5OFF',
    headline: 'Leaving so soon?',
    discount: 'Take $5 Off',
    subCopy: 'Click Continue to apply the discount and proceed with your purchase.',
    productIds: [
      '563b6496-0351-4bc8-b9fd-a624d9c38bde', // New York DMV Approved Defensive Driving Course Online (IPIRP)
      'dc333352-3f52-437d-9f33-fec1ad7f49ff', // New York DMV Approved Defensive Driving Streaming Video Course Online (IPIRP)
      '27ca066a-004e-4f1f-a146-08dde4d2bf0c', // New York DMV Approved Defensive Driving Course Online (IPIRP)
      '92d6ae7a-7e3e-41a6-840e-08dde3feec0e', // New York DMV Approved Defensive Driving Streaming Video Course Online (IPIRP)
    ],
    useNewUI: false,
    isTesting: false,
  },
  'texasdrivingschool.com': {
    coupon: 'TDSSAVE10',
    headline: 'Leaving so soon?',
    discount: 'Take 10% Off',
    subCopy: 'Click Continue to apply the discount and proceed with your purchase.',
    productIds: [
      '1efb9296-7240-4c5e-8954-6868421468eb', // Texas Parent Taught Driver Education
      '1dcb0155-e537-4c4c-97a9-08dd986d4b3a', // Texas Parent Taught Driver's Education w/ DMV Permit Prep
      '70efb450-8c97-4b5a-b82e-736b45ccc3b8', // Texas Self-Taught Driver Education
      '06881a75-c9fb-498a-92ff-08dce3af17cb', // Texas Self-Taught Driver Education
      '306138a0-62a4-42b2-3574-08ddad287d8d', // Texas Self Taught Driver Education + Permit Prep
    ],
    useNewUI: true,
    isTesting: false,
  },
  'architectstraininginstitute.com': {
    coupon: 'TAKE10ATI',
    headline: 'Leaving so soon?',
    discount: 'Take 10% Off',
    subCopy: 'Click Continue to save 10% on your total purchase.',
    productIds: [], // empty means all products on cart host domain are eligible
    useNewUI: true,
    isTesting: true,
  },
};
